<template>
    <div class="wallet_save">
        <PayModal 
            :stage="modalStage"
            :errorMessage="errorMessage"
            :sucessMessage="'Успех!'"
            @enterPin="doWithdrawal" 
            @closeModal="closeModal()"             
            v-if="modalActive" 
            :pinCode="pinCode" 
         />
    </div>
</template>

<script>
import WalletList from '@/components/WalletList.vue'
import Button from '@/components/Button.vue'
import PayModal from '@/components/PayModal.vue'

export default {
    name: "WalletTopUp",
    components: {
        WalletList,
        Button,
        PayModal,
    },
    props: {
        currencyCode: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            modalStage: 'waiting',
            amount: '',
            card: '',
            pin: '',
            errorMessage: '',
            modalActive: true,
            topUpDisabled: false,
            topupStatusIntervalId: null,
            walletListRefreshed: false,
        }
    },
    computed: {
        authToken () {
            return this.$store.state.authToken
        },
        transactionId() {
            return this.$route.query.order
        },
    },   
    mounted() {
        this.fetchTopUpStatus()
        this.topupStatusIntervalId = setInterval(this.fetchTopUpStatus, 5000); // Check every 5 seconds
    },
    beforeUnmount() {
        this.stopTopUpStatusPolling()
    },
    methods: {
        stopTopUpStatusPolling() {
            if (!this.topupStatusIntervalId) {
                return
            }

            clearInterval(this.topupStatusIntervalId)
            this.topupStatusIntervalId = null
        },
        async fetchTopUpStatus() {

            const { data } = await this.$http.get(
                '/v2/wallet/top-up/status',
                {                                 
                    "params": { ...this.$route.query }, 
                    "headers": {
                        "Authorization": "Token " + this.authToken
                    }
                }
            );
            if (data.status === "complete" || data.status === "partial_complete") {
                this.modalStage = 'success'
                if (!this.walletListRefreshed) {
                    this.walletListRefreshed = true
                    await this.$store.dispatch('refreshWalletList')
                }
                this.stopTopUpStatusPolling()
            } else if (data.status === "failed") {
                this.modalStage = 'failed'
                this.stopTopUpStatusPolling()
            }

        },
        async TopUp () {
            // this.modal_active = true;
            this.topUpDisabled = true;
            
            const { data } = await this.$http.post(
                '/v2/wallet/top-up',
                {
                    "amount": this.amount,
                    "currency_code": this.currencyCode
                },
                {                    
                    "headers": {
                        "Authorization": "Token " + this.authToken
                    }
                 }
            ); 
            if (data.status === "error") {
                this.errorMessage = data.message
            } else {
                window.location = data.url;
            }
            
            // this.topUpDisabled = false;
        },
        closeModal () {
            // this.modal_active = false;
            window.location = '/'
        }
    }
}
</script>

<style>

</style>
